module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/limited_products-b384b3d88ae10f9d049b5ef26af2b93b.png";